import { encodeBase64Url } from '@/lib/url';

/** Base path of the SCAPI resource client route. Shared by `useScapiFetcher`, `useScapiFetchClient`, and `useScapiFetchHelper`. */
export const RESOURCE_API_ROUTE = '/resource/api/client';

/**
 * Encode a SCAPI resource tuple as a base64-url string for the
 * `/resource/api/client/$resource` route. Shared by `useScapiFetcher`,
 * `useScapiFetchClient`, and `useScapiFetchHelper`.
 *
 * Two shapes are supported:
 *
 *   1. Regular SCAPI client + method + options
 *      `encodeResource('shopperProducts', 'getProduct', { params: ... })`
 *      → encoded tuple `['shopperProducts', 'getProduct', { params: ... }]`
 *
 *   2. Helper namespace + helper method + options (with `helperName`)
 *      `encodeResource('helpers', 'basket', { helperName: 'getOrCreateBasket', ... })`
 *      → encoded tuple `['helpers', 'basket', { helperName: 'getOrCreateBasket', ... }]`
 *
 * The route's `loader`/`action` accept either tuple shape.
 */
export function encodeResource(client: string, method: string, options: unknown): string {
    return encodeBase64Url(JSON.stringify([client, method, options]));
}
